import PropTypes from 'prop-types';
import React, { Fragment, useContext } from 'react';

import { SignUpContext } from '../../SignUp';

import Divider from '../../../common/Divider';
import InputField from '../../../widgets/InputField';
import DateOfBirthField from '../../../widgets/DateOfBirthField';
import CurrencySelector from '../../../widgets/CurrencySelector';

import styles from '../../SignUp.module.scss';

const SignUpFormStep1 = ({
  fields,
}) => {
  const {
    currencies,
    onPropertyChange,
    onInputBlur,
    isMobile,
  } = useContext(SignUpContext);

  const {
    first,
    last,
    'date-of-birth': dateOfBirth,
    username,
    email,
    password,
    'currency-id': currency,
    'bonus-code': bonusCode,
  } = fields;

  const inputGroupStyle = isMobile ? {} : { display: 'flex', justifyContent: 'space-between' };

  return (
    <Fragment>
      <div style={inputGroupStyle}>
        <InputField
          fullWidth={isMobile}
          inline={isMobile}
          label={first.label}
          name={first.name}
          dataHook={first.dataHook}
          type="text"
          value={first.value}
          onPropertyChange={onPropertyChange}
          className={styles.inputField}
          onInputBlur={onInputBlur}
          error={first.error}
        />
        <InputField
          fullWidth={isMobile}
          inline={isMobile}
          label={last.label}
          name={last.name}
          dataHook={last.dataHook}
          type="text"
          value={last.value}
          onPropertyChange={onPropertyChange}
          className={styles.inputField}
          onInputBlur={onInputBlur}
          error={last.error}
        />
      </div>
      <DateOfBirthField
        name={dateOfBirth.name}
        dataHook={dateOfBirth.dataHook}
        value={dateOfBirth.value}
        onPropertyChange={onPropertyChange}
        className={styles.dateOfBirthField}
        error={dateOfBirth.error}
      />
      {isMobile && <Divider style={{ marginTop: 8 }} />}
      <InputField
        label={username.label}
        name={username.name}
        dataHook={username.dataHook}
        type="text"
        placeholder="Letters, digits, & dashes only"
        value={username.value}
        onPropertyChange={onPropertyChange}
        className={styles.inputField}
        onInputBlur={onInputBlur}
        error={username.error}
        inline
      />
      <InputField
        label={email.label}
        name={email.name}
        dataHook={email.dataHook}
        type="text"
        value={email.value}
        onPropertyChange={onPropertyChange}
        className={styles.inputField}
        onInputBlur={onInputBlur}
        error={!email.redirectUrl ? email.error : ''}
        inline
      />
      <InputField
        label={password.label}
        name={password.name}
        dataHook={password.dataHook}
        type="password"
        value={password.value}
        onPropertyChange={onPropertyChange}
        onInputBlur={onInputBlur}
        error={password.error}
        className={styles.inputField}
        placeholder="Minimum length 8"
        inline
      />
      <Divider style={{ marginTop: 8 }} />
      <CurrencySelector
        currencies={currencies}
        label={currency.label}
        name={currency.name}
        dataHook={currency.dataHook}
        type="text"
        value={currency.value}
        onChange={onPropertyChange}
      />
      <Divider style={{ marginTop: 8, marginBottom: 24 }} />
      <InputField
        label={bonusCode.label}
        name={bonusCode.name}
        dataHook={bonusCode.dataHook}
        type="text"
        value={bonusCode.value}
        onPropertyChange={onPropertyChange}
        className={styles.inputField}
        onInputBlur={onInputBlur}
        error={bonusCode.error}
        inline
      />
    </Fragment>
  );
};

SignUpFormStep1.propTypes = {
  fields: PropTypes.instanceOf(Object).isRequired,
};

export default SignUpFormStep1;
